import './nav-cart-item.styles.css'
import { IoCloseSharp } from 'react-icons/io5'

const NavCartItem = ({ cat, onDelete }) => {
  const { image, title, price, quantity, id } = cat
  return (
    <div className='nav-cart-item'>
      <button
        className='nav-cart-delet-item-button'
        onClick={() => onDelete(id)} // فراخوانی تابع حذف با id محصول
      >
        <IoCloseSharp />
      </button>
      <img src={image} alt={title} className='nav-cart-item-img' />
      <div className='nav-cart-item-text-box'>
        <h3 className='nav-cart-item-title'>{title}</h3>
        <p className='nav-cart-text'>
          <span>{quantity}</span>x
          <span>{Number(price).toLocaleString('fa-IR')} تومان</span>
        </p>
      </div>
    </div>
  )
}

export default NavCartItem
